import { createSelector, createStructuredSelector } from 'reselect';

import { flow, property, isNil, map, get, orderBy, identity, toString, isEmpty } from 'lodash';

export const getReceiptsResponse = property('checks.checks.response');
const getChecksIsLoading = property('checks.checks.isLoading');
const getChecksIsLoaded = createSelector(
  [getChecksIsLoading, getReceiptsResponse],
  (isLoading, data) => {
    return !isLoading && !isNil(data);
  },
);

const getFilterCategoriesData = property('checks.filters.receiptCategories');
const getFilterYearsData = property('checks.filters.years');
const getFiltersIsLoading = property('checks.filters.isLoading');
const getFiltersIsLoaded = createSelector(
  [getFiltersIsLoading, getFilterCategoriesData, getFilterYearsData],
  (isLoading, categoriesData, yearsData) => {
    return !isLoading && (!isNil(categoriesData) || !isNil(yearsData));
  },
);

export const isLoaded = createSelector(
  [getChecksIsLoaded, getFiltersIsLoaded],
  (checksLoaded, filtersLoaded) => {
    return checksLoaded && filtersLoaded;
  },
);

const categoriesFilterMapper = createStructuredSelector({
  value: property('id'),
  label: property('title'),
});

const yearsFilterMapper = createStructuredSelector({
  value: identity,
  label: toString,
});

const receiptsDataMapper = createStructuredSelector({
  receiptId: property('receiptId'),
  originDate: property('originDate'),
  originSum: property('originSum'),
  receiptCategory: flow(property('receiptCategory'), categoriesFilterMapper),
  description: property('description'),
});

export const getReceipts = createSelector(getReceiptsResponse, (receiptsData) => {
  const receipts = get(receiptsData, 'content');

  return map(receipts, receiptsDataMapper);
});

export const getPaginationOptions = createStructuredSelector({
  number: property('number'),
  size: property('size'),
  sort: property('sort'),
  totalPages: property('totalPages'),
});

export const getFilterCategories = createSelector(getFilterCategoriesData, (categoriesData) => {
  const categories = map(categoriesData, categoriesFilterMapper);

  return orderBy([{ value: -1, label: 'Все категории' }, ...categories], 'value', 'asc');
});

export const hasChecksData = createSelector(
  getFilterCategoriesData,
  getFilterYearsData,
  (categories, years) => {
    return !isEmpty(categories) || !isEmpty(years);
  },
);

export const getFilterYears = createSelector(getFilterYearsData, (yearsData) => {
  const years = map(yearsData, yearsFilterMapper);

  return orderBy([{ value: -1, label: 'Все года' }, ...years], 'value', 'desc');
});

export const getDictionaryCategories = createSelector(
  property('checks.dictionaries.categories'),
  (categoriesData) => map(categoriesData, categoriesFilterMapper),
);

export const getRecord = property('checks.checks.record');
export const dictionariesLoading = property('checks.dictionaries.pending');
